<template>
  <template v-if="selectedOffer && productResponse">
    <FavoritesToggle
      :favorite-tracking-info="productTracking.favoriteTrackingInfo.value"
      :grade-id="selectedOffer?.grade.value"
      :is-rounded
      :offer-type
      :price="selectedOffer?.price"
      :product-uuid="productResponse?.productId"
      :tracking-info="favoritesTrackingInfo"
      zone="details"
    />
  </template>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import FavoritesToggle from '~/scopes/dashboard/favorites/toggle/FavoritesToggle.vue'
import { fromProductTrackingModel } from '~/scopes/dashboard/favorites/utils/FavoriteTrackingModel'
import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'
import { useFetchProductTracking } from '~/scopes/product-core/composables/useFetch/useFetchProductTracking/useFetchProductTracking'
import { useUrlParams } from '~/scopes/product-core/composables/useUrlParams/useUrlParams'

const { isRounded = false } = defineProps<{ isRounded?: boolean }>()

const { selectedOffer } = useFetchPickers()
const { data: productResponse } = useFetchProduct()
const { data: productTracking } = useFetchProductTracking()

const { offerType } = useUrlParams()

const favoritesTrackingInfo = computed(() => {
  return fromProductTrackingModel(productTracking.product.value)
})
</script>
